<ng-container *ngIf="expiredOffers$ | async as expiredOffers">
  <div class="rewards-wallet-redeemed-list mb-3" *ngIf="expiredOffers.Offers?.length > 0 || expiredOffers.Vouchers?.length > 0">
    <h5 class="campaign-history-title">{{ 'campaigns.offers.history.title' | translate }}</h5>
    <ng-container *ngFor="let offer of expiredOffers.Offers">
      <div class="col-12">
        <div class="loyalty-item-container-redeemed">
          <fgb-campaigns-v2-used-list-item
            [campaignEntitlement]="offer"
            [routerLink]="['/campaign-v2/details/offer/', offer.CampaignId]"
          ></fgb-campaigns-v2-used-list-item>
        </div>
      </div>
    </ng-container>
    <ng-container *ngFor="let voucher of expiredOffers.Vouchers">
      <div class="col-12">
        <div class="loyalty-item-container-redeemed">
          <fgb-campaigns-v2-used-list-item
            [campaignEntitlement]="voucher"
            [routerLink]="['/campaign-v2/details/voucher/', voucher.CampaignId]"
          ></fgb-campaigns-v2-used-list-item>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
